module.exports = __webpack_public_path__ + "img/trip.5cdbbbbc.jpg";